"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
_export_star(require("./constants"), exports);
_export_star(require("./meeting-action-items"), exports);
_export_star(require("./meeting-agenda-items"), exports);
_export_star(require("./meeting-notes"), exports);
_export_star(require("./meeting-recurring-series"), exports);
_export_star(require("./meeting-transcripts"), exports);
_export_star(require("./meeting-workspace-participation-history"), exports);
_export_star(require("./meeting-workspaces"), exports);
_export_star(require("./meetings"), exports);
function _export_star(from, to) {
    Object.keys(from).forEach(function(k) {
        if (k !== "default" && !Object.prototype.hasOwnProperty.call(to, k)) {
            Object.defineProperty(to, k, {
                enumerable: true,
                get: function() {
                    return from[k];
                }
            });
        }
    });
    return from;
}
